import { AskRequest, AskResponse, ChatRequest, Conversation } from "./models";

//const BASE_URL = "http://localhost:5000";
const BASE_URL = "";
//const BASE_URL = "https://www.compgenieqa.ford.com/";

function getAccessToken() {
    // todo
    try {
        //const keyLookup = "msal.36ab7d87-e480-43e7-a4fb-fb59a6c9589b.active-account-filters";
        const keyLookup = "msal.ae5fc2ab-d8a9-4544-b282-23bf5d57bfed.active-account-filters";
        const homeAccountId = JSON.parse(localStorage[keyLookup]).homeAccountId;
        //const accessTokenKey = `${homeAccountId}-login.windows.net-accesstoken-36ab7d87-e480-43e7-a4fb-fb59a6c9589b-c990bb7a-51f4-439b-bd36-9c07fb1041c0-user.read profile openid email--`;
        const accessTokenKey = `${homeAccountId}-login.windows.net-accesstoken-ae5fc2ab-d8a9-4544-b282-23bf5d57bfed-c990bb7a-51f4-439b-bd36-9c07fb1041c0-user.read profile openid email--`;
        const accessToken = JSON.parse(localStorage[accessTokenKey]).secret;
        console.log(accessToken);
        return accessToken;
    } catch (e) {
        console.error(e);
        console.log("user not logged in");
    }
}

function getWebroleAccessToken() {
    try {
        // This key is used to find the active user's account ID
        //const keyLookup = "msal.36ab7d87-e480-43e7-a4fb-fb59a6c9589b.active-account-filters";
        const keyLookup = "msal.ae5fc2ab-d8a9-4544-b282-23bf5d57bfed.active-account-filters";
        const homeAccountId = JSON.parse(localStorage[keyLookup]).homeAccountId;

        // Construct the specific key for the ID token
        //const idTokenKey = `${homeAccountId}-login.windows.net-idtoken-36ab7d87-e480-43e7-a4fb-fb59a6c9589b-c990bb7a-51f4-439b-bd36-9c07fb1041c0---`;
        const idTokenKey = `${homeAccountId}-login.windows.net-idtoken-ae5fc2ab-d8a9-4544-b282-23bf5d57bfed-c990bb7a-51f4-439b-bd36-9c07fb1041c0---`;

        // Retrieve the object from local storage and parse it
        const idTokenObject = JSON.parse(localStorage[idTokenKey]);

        // Extract the secret (the ID token itself)
        const idToken = idTokenObject.secret;

        console.log(idToken);
        return idToken;
    } catch (e) {
        console.error("Failed to retrieve the ID token:", e);
        console.log("This could be because the user is not logged in or the key is incorrect.");
    }
}

export async function askApi(options: AskRequest): Promise<AskResponse> {
    const response = await fetch(BASE_URL + "/ask", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
        },
        body: JSON.stringify({
            question: options.question,
            approach: options.approach,
            overrides: {
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                temperature: options.overrides?.temperature,
                prompt_template: options.overrides?.promptTemplate,
                prompt_template_prefix: options.overrides?.promptTemplatePrefix,
                prompt_template_suffix: options.overrides?.promptTemplateSuffix,
                exclude_category: options.overrides?.excludeCategory
            }
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

function setConversationId(conversationId: string) {
    sessionStorage.setItem("conversationId", conversationId);
    sessionStorage.setItem("conversationLastModifiedDt", Date.now().toString());
}

export function resetConversationId() {
    sessionStorage.removeItem("conversationId");
    sessionStorage.removeItem("conversationLastModifiedDt");
}

function getConversationId() {
    const id = sessionStorage.getItem("conversationId");
    const t = sessionStorage.getItem("conversationLastModifiedDt");
    if (id == null || t == null) {
        resetConversationId();
        return null;
    }
    const ALLOWED_WAIT = 24 * 60 * 60 * 1000;
    // const ALLOWED_WAIT = 10 * 1000;
    const now = Date.now();
    const lastModified = parseInt(t);
    if (now - lastModified < ALLOWED_WAIT) {
        return id;
    }
    resetConversationId();
    return null;
}

export async function chatApi(options: ChatRequest): Promise<Conversation> {
    const conversationId = getConversationId();
    const accessToken = getWebroleAccessToken();
    const response = await fetch(BASE_URL + "/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
        },
        body: JSON.stringify({
            conversationId,
            accessToken,
            history: options.history,
            approach: options.approach,
            overrides: {
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                temperature: options.overrides?.temperature,
                prompt_template: options.overrides?.promptTemplate,
                prompt_template_prefix: options.overrides?.promptTemplatePrefix,
                prompt_template_suffix: options.overrides?.promptTemplateSuffix,
                exclude_category: options.overrides?.excludeCategory,
                suggest_followup_questions: options.overrides?.suggestFollowupQuestions
            }
        })
    });

    const parsedResponse: Conversation = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error((parsedResponse as any).error || "Unknown error");
    }
    setConversationId(parsedResponse.id);
    return parsedResponse;
}

export const sendFeedback = async (messageId: number, action: string) => {
    const conversationId = getConversationId();

    const res = await fetch(`${BASE_URL}/feedback/${conversationId}/${messageId}/${action}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
        }
    });
    const data: Conversation = await res.json();
    setConversationId(data.id);
    return data;
};

export const sendFeedbackMessage = async (messageId: number, feedback: string | null, feedbackCategory: string | null) => {
    const conversationId = getConversationId();
    if (!feedbackCategory) {
        feedbackCategory = "na";
    }
    if (!feedback) {
        feedback = "na";
    }
    if (feedback.includes("/") || feedback.includes("\\")) {
        feedback = feedback.replace(/[\/\\]/g, "%");
    }
    const encoded_feedback = encodeURIComponent(feedback);
    const encoded_feedbackCategory = encodeURIComponent(feedbackCategory);
    console.log("FrontEnd: " + encoded_feedback + encoded_feedbackCategory);
    const res = await fetch(`${BASE_URL}/feedbackmessage/${conversationId}/${messageId}/${encoded_feedback}/${encoded_feedbackCategory}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
        }
    });
    const data: Conversation = await res.json();
    setConversationId(data.id);
    return data;
};

export const getHistory = async () => {
    const conversationId = getConversationId();
    const res = await fetch(`${BASE_URL}/history/${conversationId}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getAccessToken()}`
        }
    });
    const data: Conversation = await res.json();
    if (!data.id || !data.messages) {
        throw Error((data as any).error || "Something went wrong");
    }
    setConversationId(data.id);
    return data;
};

export function getCitationFilePath(citation: string): string {
    return `${BASE_URL}/content/${citation}`;
}
